// Single source for this app's support WhatsApp number -- was hardcoded
// separately in PublicProfile.js (the deactivated-card gate); pulled out
// here so ActivationBanner.js's not-eligible-yet CTA can't quietly drift
// onto a different number.
export const SUPPORT_WHATSAPP_NUMBER = '923183009464';

// wa.me wants digits only, no leading '+', and the message pre-filled
// via a plain `text` query param -- same construction every call site
// already used inline before this existed.
export const buildSupportWhatsAppUrl = (message) =>
  `https://wa.me/${SUPPORT_WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const SUPPORT_EMAIL = 'support@digitalcontactcard.com';

export const buildSupportMailtoUrl = (message) =>
  `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(
    'Activation support'
  )}&body=${encodeURIComponent(message)}`;
